import React, { useEffect, createElement } from 'react';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { PainSolutionSection } from './components/PainSolutionSection';
import { EbookShowcase } from './components/EbookShowcase';
import { SalesLetterSection } from './components/SalesLetterSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { ValueSummary } from './components/ValueSummary';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    // Meta Pixel - inline script initialization
    const w = window as any;
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w.fbq = n;
      w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Load fbevents.js
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', '854325104356227');
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-background font-sans text-text-main selection:bg-primary/20 pb-16 md:pb-0" data-id="element-0">
      <StickyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSolutionSection data-id="element-4" />
        <EbookShowcase data-id="element-5" />
        <SalesLetterSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <ValueSummary data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <FloatingCTA data-id="element-12" />
      <noscript data-id="element-13">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=854325104356227&ev=PageView&noscript=1" alt="" data-id="element-14" />
      </noscript>
    </div>;
}